import { AnchorHTMLAttributes } from 'react';

import { resolveTitle } from './resolve-title';

export type TAnchorWithTitleProps =
  AnchorHTMLAttributes<HTMLAnchorElement>;
export const AnchorWithTitle = ({
  href,
  children,
  title: _title,
  target,
  ...props
}: TAnchorWithTitleProps) => {
  const title = resolveTitle({ children, title: _title });
  return (
    <a
      title={title}
      href={href}
      target={target ?? '_blank'}
      {...props}
    >
      {children ?? title}
    </a>
  );
};
